const alertUtils = {
  unexpectedError: log => {
    alert("😬 Oops unexpected error.");
    window.l = log;
    console.log(log);
  }
};
export default alertUtils;
